import React, { useCallback, useRef, useState } from 'react';
import { t } from 'i18next';

import { useNotifications } from '../../../context/Notifications';
import { DropdownMenu } from '../../form';
import { debounce } from 'lodash';
import { Icon } from '../../UI';
import WindowWidget from '../WindowWidget';
import NotificationSettings from './NotificationSettings';
import { useModalContext } from '../../../context/Modal';
import { Loading } from '../../UI';
import ManageAlerts from './SmartAlerts';
import { useOutsideClick } from '../../../hooks/useOutsideClick';
import NotificationsList from './NotificationsList';
import { logger } from '../../../helpers/logger';
import { useSidebar } from '../../../context/Sidebar';

export const Notifications: React.FC = () => {
  const {
    notificationsList,
    nextToken,
    loading: loadingNotifications,
    search: searchNotifications,
    loadMore,
    clearAlertNotifications,
  } = useNotifications();
  const { dispatch: dispatchModal } = useModalContext();
  const { isOpen, setIsOpen } = useSidebar();

  const [isManageMode, setIsManageMode] = useState(false);

  const boxRef = useRef<HTMLDivElement | null>(null);

  // useOutsideClick(boxRef, (ev, x) => {
  //   if (ev.target?.parentNode?.id !== 'notification-button') {
  //     setIsOpen(false);
  //   }
  // });

  const search = useCallback(
    debounce((event) => {
      searchNotifications(event.target.value);
    }, 500),
    []
  );

  logger.log('isManageMode', isManageMode);

  if (!isOpen) return <></>;

  return isManageMode ? (
    <ManageAlerts goBack={() => setIsManageMode(false)} />
  ) : (
    <WindowWidget
      ref={boxRef}
      title={t('alerts.notifications')}
      onChange={search}
      actions={[
        <div key="clearAlertNotifications">
          <DropdownMenu
            dropdownItems={[
              <span onClick={clearAlertNotifications}>
                {t('alerts.deleteAll')}
              </span>,
            ]}
            dropdownTooltipClassName="bg-white border-solid border-grey-10 border shadow-md"
          >
            <Icon svgName="options" className="cursor-pointer" />
          </DropdownMenu>
        </div>,
        <DropdownMenu
          key={'notificationSettings'}
          dropdownItems={[
            <span onClick={() => setIsManageMode(true)}>
              {t('alerts.manageSmartAlerts')}
            </span>,
            <span
              onClick={() =>
                dispatchModal({
                  element: <NotificationSettings />,
                  title: t('alerts.notificationSettings'),
                })
              }
            >
              {t('alerts.notificationSettings')}
            </span>,
          ]}
          dropdownTooltipClassName="bg-white border-solid border-grey-10 border shadow-md"
          hideOnItemClick
        >
          <Icon svgName="settings" className="cursor-pointer" />
        </DropdownMenu>,
        <Icon
          svgName="close"
          className="h-3 cursor-pointer"
          onClick={() => setIsOpen(false)}
          key="3"
        />,
      ]}
    >
      <div className={'flex flex-col h-full'}>
        {loadingNotifications && (
          <div className={'flex justify-center w-full mt-2'}>
            <Loading status={true} size={'small'} />
          </div>
        )}
        <div className={'w-full h-full'}>
          <NotificationsList
            hasNextToken={!!nextToken}
            isNextDataLoading={loadingNotifications}
            notificationsList={notificationsList}
            loadMore={loadMore}
          />
        </div>
      </div>
    </WindowWidget>
  );
};
